<template>
    <div>
        <div v-if="filteredItems.length" class="animation-grid renderfix">
                <div v-for="(item, i) in filteredItems" :key="item.id">
                    <pm-smart-animation-item
                            @click.native="$emit('play', item.id)"
                            :key="i + '-' +  item.id"
                            v-if="(category === '' || item.categories.includes(category))"
                            :item="item"
                            :data-idx="i+1"
                            :class="[i < 16 ? 'pm-animation-fade-in-slide-down' : '']"
                            :style="'--delay: '+((i+1) * 25 + (tagIdx > 0 ? 650 : 0)) +'ms'"
                    />
                    <!--div v-if="(category === '' || item.categories.includes(category))">
                        <img :onerror="(e) => { e.target.src = missingImageSrc; }" style="max-width: 100%;" :src="'https://cdn.denticalc.com/videos/' + item.video + '.thumb.jpg'" />
                        {{ item.title.en }}
                    </div-->

                </div>
        </div>
        <div v-else style="display: flex; align-items: center; height: Calc(100vh - 233px); width: 100%; text-align: center">
            <span style="font-style:italic; font-weight: 300; font-size: 18px; color: #CCCCCC; display: block; width: 100%;">
                {{ $t('core.no_results') }}
            </span>
        </div>
    </div>
</template>

<style lang="scss">

.animation-grid {
    display: grid;
    gap: 0px;
}

.pm-animations-grid-1 .animation-grid {
    grid-template-columns: repeat(1, 100%);
}

.pm-animations-grid-2 .animation-grid {
    grid-template-columns: repeat(2, 50%);
    margin: 0 -8px;
}

.pm-animations-grid-3 .animation-grid {
    grid-template-columns: repeat(3, 33%);
    margin: 0 -8px;
}

@media (min-width: 700px) {
    .animation-grid,
    .animation-grid-3 {
        grid-template-columns: repeat(3,calc(33% - 4px));
    }

    .pm-smart-animation-item--region {
        font-size: 12px !important;
    }

    .pm-smart-animation-item--title,
    .pm-smart-animation-item--subtitle {
        font-size: 13px !important;
        line-height: 1.3 !important;
    }

    .pm-smart-animation-item--subtitle {
        color: #2f2f2f !important;
    }
}
</style>

<script>
import PmSmartAnimationItem from './item';
import {animationCategories} from '../../configs/animations';

export default {
    components: {
        PmSmartAnimationItem,
    },
    props: {
        category: {
            type: String,
            default: '',
        },
        favourites: {
            type: Boolean,
            default: false,
        },
        tagIdx: {
            type: Number,
            default: 0,
        }
    },
    data: () => ({
        filteredItems: null,
        search: null,
        animationCategories,
        animateList: true,
        maxListItems: 16,
        missingImageSrc: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABcBAMAAAASWgMGAAAAJFBMVEXe3t6hoaGmpqawsLDAwMDOzs7S0tLJycm1tbWrq6vX19e6urrBkJM3AAABHUlEQVRYw+3VLXLCYBSF4Vta0mlrOCWdIltXmeyg7ACLy+Bw4LBgWAFgQWFZInxD4ExA3qOY+6iok593Mp+FEEIIITym9mwO9JYD3eActa5odAjQxgT6aMhFi3+TdLlf4KRnTtM0UlktK/3P+QZgdfthf8zhFcDaGsYA/h2Tz9dFGgGFOfzev2ULn+axQ9fE2vxwMn18mQoDmdR9oJaZ+yZPzUAlJ0WBXsBJUaApJ0WB3sFJbyD+OZzUBCrR4aQv0OF89QEMOOkL9H2JkxsnnYG2dZyCk+5AlzicdAeq48gmsxQoxak4KQh0jsNJRaAUh5OSQCkOJyWBUhylDCeV+gxCrj+DCvkZlOIwjyRQRz6ZVfJJAiyEEEII4bEcAe1CIm7ZcUR3AAAAAElFTkSuQmCC",
    }),
    computed: {
        items() {
            return this.$store.state.animation.animationItems;
        },
    },
    created() {
        this.$store.getters['animation/animationItems'];

        if (this.favourites) {
            this.filteredItems = this.getFavourites(this.items);
        } else if (this.category!=='') {
            this.filteredItems = this.sortItems(this.items).filter((item) =>
                item.categories.includes(this.category)
            );
        } else {
            this.filteredItems = this.sortItems(this.items);
        }
    },
    mounted() {
        if (this.searchable && this.$store.state.animation.lastSearch !== null) {
            this.search = this.$store.state.animation.lastSearch;

            this.filterItems();
        }

        if (this.searchable && this.$store.state.animation.scrollPos > 0) {
            const el = document.getElementById('app-sidebar');

            el && el.scrollTo(0, this.$store.state.animation.scrollPos);
        }

        window.setTimeout(() => {
            this.maxListItems = 20;
            this.$nextTick(()=>{
                this.initInfiniteScroll();
            });
        }, 300);
    },
    beforeDestroy() {
        this.searchable && (this.$store.state.animation.lastSearch = this.search);
    },
    watch: {
        search() {
            this.filterItems();
        },
        category(currentValue, prevValue) {
            this.filteredItems = this.sortItems(this.items).filter((item) => {
                return Array.isArray(item.categories)
                    ? item.categories.includes(this.category)
                    : false;
            });
        },
    },
    methods: {

        initInfiniteScroll() {
            try {
                this.observer = new IntersectionObserver(entry => {
                    if (entry[0].isIntersecting) {
                        this.observer.unobserve(entry[0].target);
                        let idx = entry[0].target.dataset.idx;
                        if (this.filteredItems.length <= this.maxListItems) return;
                        if (this.maxListItems < idx + 20) {
                            this.maxListItems = parseInt(idx) + 20;
                            this.$nextTick(() => {
                                const observableEls = document.querySelectorAll(".pm-infinite-scroll-observable");
                                if (observableEls) {
                                    this.observer.observe(observableEls[observableEls.length - 1]);
                                }
                            });
                        }
                    }
                });

                const observableEls = document.querySelectorAll(".pm-infinite-scroll-observable");

                if (observableEls) {
                    observableEls.forEach(el => {
                        this.observer.observe(el);
                    });
                }
            } catch (error) {
                captureException(error);
                // Show all items on infinite scroll failure
                this.maxListItems = 999;
            }
        },
        /**
         *
         * @return {string[]}
         */
        getVideoBookmarks() {
            try {
                /** @type {string[]} */
                const videoBookmarks = JSON.parse(localStorage.getItem('videoBookmarks') || '[]');

                return videoBookmarks;
            } catch (error) {
                captureException(error);

                return [];
            }
        },
        getFavourites(items) {
            const favvedItems = this.getVideoBookmarks();

            return items.filter((item) => Array.isArray(favvedItems) ? favvedItems.includes(item.id) : false);
        },
        sortItems(items) {
            return items;
            try {
                const favvedItems = this.getVideoBookmarks();
                let viewCounter = {};
                if (localStorage.getItem('videoViewCounter') !== null) viewCounter = JSON.parse(localStorage.getItem('videoViewCounter'));

                return items.sort((a, b) => {
                    const isFavvedA = favvedItems.includes(a.id);
                    const isFavvedB = favvedItems.includes(b.id);
                    const playedA = typeof viewCounter[a.id] !== 'undefined' ? viewCounter[a.id].played : 0;
                    const playedB = typeof viewCounter[b.id] !== 'undefined' ? viewCounter[b.id].played : 0;
                    // Sort favved
                    if (isFavvedA && !isFavvedB) return -1;
                    if (!isFavvedA && isFavvedB) return 1;
                    // Sort by views
                    if (playedA > playedB) return -1;
                    if (playedA < playedB) return 1;
                    return 0;
                });
            } catch(error) {
                captureException(error);
                return items;
            }
        },
        /*getStyle() {
            if (this.$vuetify.breakpoint.lgAndUp) {
                return 'width: 16.666%;';
            }

            if (this.$vuetify.breakpoint.mdAndUp) {
                return 'width: 25%;';
            }

            if (this.$vuetify.breakpoint.smAndUp) {
                return 'width: 33%;';
            }

            return 'width: 100%;';
        },*/
        filterItems() {
            if (!this.search || this.search.trim().length < 3) {
                this.filteredItems = this.items;

                return true;
            }

            const tmp = [];
            const {items} = this;

            for (const i in items) {
                if (!Object.prototype.hasOwnProperty.call(items[i], 'title')) {
                    continue;
                }

                const foldedTitle = Helper.accentFoldedHighlight(this.items[i].title, this.search.trim());

                if (foldedTitle.indexOf('<b>') >= 0) {
                    const data = JSON.parse(JSON.stringify(this.items[i]));

                    data.title = foldedTitle;

                    tmp.push(data);
                }
            }

            this.filteredItems = tmp;
        },
    },
};
</script>
